import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const CelluleUrlSite = ({ siteUrl }) => {
  if (!siteUrl) return null;

  const handleLinkClick = (event) => {
    event.stopPropagation(); // Empêche la propagation du clic vers les éléments parents
  };

  return (
    <a
      href={siteUrl}
      alt={siteUrl}
      title={siteUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: "flex", cursor: "pointer" }}
      onClick={handleLinkClick}
    >
      <OpenInNewIcon />
    </a>
  );
};

export default CelluleUrlSite;
